/**
 * Beam-specific typography tokens passed to photon UI iframes.
 * These extend the core theme tokens with Beam's display font and type scale.
 */
export const beamTypographyTokens: Record<string, string> = {
  '--font-display': "'Sora', 'Space Grotesk', -apple-system, BlinkMacSystemFont, sans-serif",
  '--text-3xl': '2rem',
  '--text-2xl': '1.5rem',
  '--text-xl': '1.25rem',
  '--text-lg': '1.1rem',
  '--text-md': '0.9rem',
  '--text-sm': '0.8rem',
  '--text-xs': '0.7rem',
  '--text-2xs': '0.6rem',
};
